import getUserManager from './userManager';

/**
 * Sign in an user
 */
export const signIn = () =>
  getUserManager().then((userManager) =>
    userManager
      .signinSilent()
      .then((user) => user)
      .catch(() => userManager.signinRedirect())
  );

export default signIn;